import { WizDateUtils, WizFileUtils, WizMathUtils, WizNumberUtils } from '@wizeoo/akm-core-lib';
import { PopUpManager, WizAgGrid, WizCommandManager, WizIcon, WizPopUp, WizTranslationManager } from '@wizeoo/akm-component-lib';
import { ColDef, CsvExportParams, ProcessCellForExportParams, ValueFormatterParams } from 'ag-grid-community';
import { Column, ColumnGroup } from 'ag-grid-community';
import { Cell, CellValue, Row, Workbook, Worksheet } from 'exceljs';
import * as fs from 'file-saver';

import { ViewData } from '../../model/view.data';
import { ChronocodeVO } from '../../vo/core/chronocode.vo';
import { FreedataValueVO } from  '../../vo/core/freedatavalue.vo';
import { IFreedataWidget, IWidget } from '../widgets/i-widget';
import { ExcelSheetVo, ExcelColumn } from './excel-sheet.vo';
import { FeiVO } from '../../vo/workingdata/fei.vo';
import { FreeDataVO } from "../../vo/core/freedata.vo";
import { CompositeSourcePack } from "../../command/core/sync/sync.service";
import { FreedataArgsVO } from "../../vo/core/freedataargs.vo";
import { IHeaderColumn } from '@ag-grid-community/core';
import { Baseline, WidgetConfigurationObj, WidgetConfigurationItemObj, BaselineValue, VisionFilterKey, VisionKey, Measure } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { WizColDef } from '../../manager/workingdata/fei.engine';
import { BaselineEngine, ComputeResult, EM_ACTION, FIELD_KIND, FeiKeyDef, FormulaCoreEngine, IBaselineValue, KeyPair, MeasMode, MeasureCoreEngine, MeasureVO, Triggers, VisionVO, WizConstants, DataLoadObj, WorkComVO, WorkcomParameters } from '@wizeoo/akm-compute-lib';
import { WidgetLine } from '@wizeoo/akm-compute-lib';
import { UpdateEntry, UpdateRequest } from '../../command/core/sync/sync.service';
import { ExcelErrorPop } from './excel-error.pop';

// gestion de l'export PDF
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { ElementRef } from '@angular/core';
(pdfMake as any).vfs = pdfFonts.vfs;

import domtoimagemore from 'dom-to-image-more';
import { PDF_PAGE_KIND } from '../../model/enums';
import { AttachmentService } from '../../command/core/attachment/attachment.service';
import { first, forkJoin, Observable, of } from 'rxjs';
import { WorkcomCommitCmd } from '../../command/em/workcomcommit.cmd';

// structure d'une colonne pour l'export
export interface PDFPage  {
  widget: IWidget; // le widget source
  element: ElementRef; // contenu de widget cible
  width?: number; // largeur
  height?: number; // hauteur
  kind?: PDF_PAGE_KIND; // le type de rendu à générer
  bin?: any; // l'image générée
  html?: any; // le contenu html
  content?: any[]; // le contenu à injecter dans le PDF
  lastPage?: boolean; // dernière page, pas de pageBreak
  isHeader?: boolean; // le titre de widget est 'header'
  noHead?: boolean; // le titre contient noHead
  noFoot?: boolean; // le titre contient noFoot
}


// structure d'une colonne pour l'export
export interface ExcelExportColumn  {
  label; // libellé
  size: number; // taille pour collSpan
  background?: string; // couleur de fond
  font?: string; // couleur de police
  // pour les cellules
  cellBackground?: string; // couleur de fond
  cellFont?: string; // couleur de police
  cellBold?: string; // bold
  colDef: ColDef;
  hidden?: boolean; // colonne masquée
  sourceIndex?: number; // l'indice d'origine dans le rawData
  columnIndex?: number; // indice réel en tenant compte des colonnes masquées
}


/**
 * Classe utilitaire pour les exports de grid / listes
 */
export class ExcelExportEngine {

  protected model: Model = null;
  constructor(model: Model) {
    this.model = model;
  }




  // ######################################
  // génération de l'export Excel, formatté, depuis l'agGrid
  // ######################################

  /**
   * demande d'export depuis l'IHM, image en PDF
   * @param filename nom du fichier cible
   * @param widget source
   */
  public exportAsPdf(filename: string, widget: IWidget, element: ElementRef, targetWidth: string = null, targetHeight: string = null): void {

    WizCommandManager.setLock(true);
    setTimeout(() => {
      if(!!targetHeight) {
        element.nativeElement.style.height = targetHeight;
      }
      
      const DATA = element.nativeElement;
      const width: number = element.nativeElement.offsetWidth;
      const height: number = element.nativeElement.offsetHeight;

      domtoimagemore.toBlob(DATA).then(function (imgData) {
        
        var reader = new FileReader();
        reader.readAsDataURL(imgData); 
        reader.onloadend = function() {
          var base64data = reader.result;                
          // console.log(base64data);

          const docDefinition: any = {
          // a string or { width: number, height: number }
          // pageSize: 'A3',
          pageSize: {
              width: width + 20,
              height: height + 20
            },
          // by default we use portrait, you can change it to landscape if you wish
          pageOrientation: 'landscape',
                
          content: [
            {
              image: base64data,
              width, // : 2000, // coord.offsetWidth, // ajustable
              height, // : 1000 //coord.offsetHeight
            },
          ],
          pageMargins: [10, 10, 10, 10],
        };

        pdfMake.createPdf(docDefinition).download(filename + '.pdf');
        if(!!targetHeight) {
          element.nativeElement.style.height ='100%';
        }
        
        WizCommandManager.setLock(false);

        }

    
    });

    }, 0);

  }
    
  /**
   * demande d'export depuis l'IHM
   * @param filename nom du fichier cible
   * @param widget source
   */
  public exportAsExcel(filename: string, widget: IWidget, intercept: boolean = false): Worksheet {
    
    // prise des colonnes
    const grid: WizAgGrid<any> = widget['agGrid'];
    const allGp: any[] = grid.columnApi.getAllDisplayedColumnGroups(); // prise des groupes / colonnes

    // console.log('allGp', allGp);
    const cols: Column[] = grid.columnApi.getAllDisplayedColumns(); //  []; // grid.columnApi.getAllColumns(); // prise de toutes les colonnes basiques, pour le rendu

    if (cols.length <= 0) { // pas de colonnes, pas d'export
      return;
    }

    let countHeader: number = 1; // profondeur d'entête
    let gpDeep: IHeaderColumn = allGp[0]; // on prend le 1er, tous les groupes ont la même profondeur
    while(gpDeep.hasOwnProperty('children')) {
      // console.log('deep', gpDeep);
      countHeader++;
      gpDeep = gpDeep['children'][0];
    }
    // console.log('exportAsExcel', cols);
    

    // prise des données
    let params : CsvExportParams  = { columnSeparator: ViewData.EXCEL_EXPORT_SEPARATOR, suppressQuotes: true};//, allColumns:true };
    // processor
    params.processCellCallback = this.processCellCallback;
    // extraction des lignes
    const rawData: string[] = grid.api
      .getDataAsCsv(params)
      .split(/\r\n/);
    let rawArr: string[][] = rawData.map((s) => s.split(ViewData.EXCEL_EXPORT_SEPARATOR));
    // possibles multi-levels
    rawArr.splice(0, countHeader); // extraction de la ligne de titre

    if (rawArr.length <= 0) { // pas de données, pas d'export
      return;
    }


    let idx: number =0;
    let binColumns: Map<number, Column> = new Map(); // les colonnes avec des médias
    
    // on cherche une colonne Bin exportable
    cols.forEach((c: any) => {
      if([FIELD_KIND.BINARY, FIELD_KIND.BINARY_MULTI].includes(c.colDef.datakind)) {
        if(!!c.colDef.wcio?.exportable && !c.colDef.wcio?.hiddenCol) {
          // console.log('c', c.getColDef());
          binColumns.set(idx, c);
        }
      }
      idx++;
    });

    if(binColumns.size <= 0) {
      return this.doExportAsExcel(filename, widget, cols, rawArr, null, intercept);
    }

    // Préparation des requêtes pour les médias
    const pendingBins: {row: number, col: number, obs: Observable<string|undefined>}[] = [];

    // Collecte des promesses pour chaque cellule image/binaire
    for (let row = 0; row < rawArr.length; row++) {
      for (let col = 0; col < rawArr[row].length; col++) {
        if(binColumns.has(col)) {
          //console.log('got you', col, binColumns.get(col).getColDef());
          const blobId = rawArr[row][col].split(WizConstants.KEY_SEPARATOR)[0];
          pendingBins.push({
            row, col,
            obs: AttachmentService.getInstance().downloadAttachmentForWidget(blobId, true).pipe(first())
          });
        }
      }
    }

    // On attend toutes les requêtes binaires/médias
    const binRequests = pendingBins.map(x => x.obs ?? of(undefined));
    forkJoin(binRequests).subscribe(resolvedMedias => {
      // Injection dans rawArr
      resolvedMedias.forEach((mediaBase64, idx) => {
        const { row, col } = pendingBins[idx];
        rawArr[row][col] = mediaBase64 ?? '';
      });

      return this.doExportAsExcel(filename, widget, cols, rawArr, binColumns, intercept);

    });
  };
    
  /**
   * post-traitement sur l'export CSV du grid
   * @param params 
   * @returns 
   */
  private processCellCallback(params: ProcessCellForExportParams): any {
     const colDef: any = params.column.getColDef();

      if(colDef.fkd?.isChrono) { // export natif pour Chronos et FD
        if (colDef.valueFormatter) {
          const valueFormatterParams: ValueFormatterParams = {
            ...params,
            data: params.node.data,
            node: params.node!,
            colDef: params.column.getColDef()
          };
          return colDef.valueFormatter(valueFormatterParams);
        }
        return params.value;
      } 

      // retour de valeur pour les champs texte
      if (colDef.datakind === FIELD_KIND.STRING || colDef.datakind === FIELD_KIND.COMMENT) {
        if(params.value === 'null') {
          return null;
        } else {
          return params.value;
        } 
      }

      // retour de valeur pour les champs workflow
      if (colDef.datakind === FIELD_KIND.WORKFLOW) {
        if(params.value === 'null' || !params.value) {
          return null;
        } else {
          let res: string = Model.getInstance().workflowEngine.formatForExport(params.value);
          // res = ExcelExportEngine.toRichText(res);
          // console.log('res', res);
          return res;
        } 
      }

      // retour de valeur pour les champs numériques
      if (colDef.datakind === FIELD_KIND.INT || colDef.datakind === FIELD_KIND.NUMBER) {
        if(!isNaN(Number(params.value))) {
          return params.value;
        } else {
          return null;
        }
        
      }

      // retour de valeur pour les champs numériques
      if (colDef.datakind === FIELD_KIND.BOOLEAN ) {
        if(!isNaN(Number(params.value))) {
          return params.value;
        } else {
          return null;
        }
        
      }

      if (colDef.datakind === FIELD_KIND.BINARY || colDef.datakind === FIELD_KIND.BINARY_MULTI) {
        let res: string = null;
        if(!!params.value) {
          let one: string = params.value.split(WizConstants.KEY_SEPARATOR)[0];
          res = one;
        }
        
        // console.log('Excel binary', params);
        return res;
      }


      // formatage des dates
      if(colDef.datakind === FIELD_KIND.DATE) {
        // console.log('export Date',colDef, params.value);
        if (!!params.value && params.value > 0) {
          let ExcelVal: number =  null;
          try {
            ExcelVal = WizDateUtils.dayDiff(WizDateUtils.stringToDate(params.value), WizDateUtils.numberToDate(19000101))
          } catch(e: any) {
            console.log('bad date param', params);
          }
          return ExcelVal > 0 ? ExcelVal + 1 : null ;
        }
        return null;
      }

      // retour par défaut
      if (colDef.valueFormatter) {
        const valueFormatterParams: ValueFormatterParams = {
          ...params,
          data: params.node.data,
          node: params.node!,
          colDef: params.column.getColDef()
        };
        // console.log('basic format', colDef.valueFormatter(valueFormatterParams));
        let res: any = colDef.valueFormatter(valueFormatterParams);
        return res;
      }
  }

  /**
   * Convertit une couleur 'rgba(...)' ou Hexa 'RRGGBBAA' en Hexa ARGB
   * Retourne toujours une chaîne de 8 caractères (AARRGGBB)
   */
  private toArgbHex(input) {
    let a, r, g, b;
    if (typeof input === "string" && input.startsWith("rgba(")) {
      // Parse rgba(r, g, b, a)
      const match = /rgba\s*\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)[\s,]+([01]?\.?\d*)\s*\)/i.exec(input);
      if (!match) throw new Error("Format RGBA invalide");
      r = parseInt(match[1]);
      g = parseInt(match[2]);
      b = parseInt(match[3]);
      a = Math.round(parseFloat(match[4]) * 255);
      // console.log('alpha', a);

    } else if (typeof input === "string" && /^[0-9a-f]{8}$/i.test(input)) {
      // Hexa RRGGBBAA
      r = parseInt(input.substr(0, 2), 16);
      g = parseInt(input.substr(2, 2), 16);
      b = parseInt(input.substr(4, 2), 16);
      a = parseInt(input.substr(6, 2), 16);
    } else if (typeof input === "string" && /^[0-9a-f]{6}$/i.test(input)) {
      // Hexa RRGGBBAA
      r = parseInt(input.substr(0, 2), 16);
      g = parseInt(input.substr(2, 2), 16);
      b = parseInt(input.substr(4, 2), 16);
      a = 'FF';
    } else {
      throw new Error("Format non reconnu");
    }
    // Forme ARGB
    return (
      a.toString(16).padStart(2, "0").toUpperCase() +
      r.toString(16).padStart(2, "0").toUpperCase() +
      g.toString(16).padStart(2, "0").toUpperCase() +
      b.toString(16).padStart(2, "0").toUpperCase()
    );
  }

  // Prend un hexa ARGB ("AARRGGBB") et renvoie l'hexa RGB résultant sur blanc ("RRGGBB")
  private argbToRgbOnWhite(argb) {
    if (!/^[0-9a-fA-F]{8}$/.test(argb)) throw new Error("Format ARGB attendu (AARRGGBB)");
    const A = parseInt(argb.substring(0,2), 16) / 255;
    const R = parseInt(argb.substring(2,4), 16);
    const G = parseInt(argb.substring(4,6), 16);
    const B = parseInt(argb.substring(6,8), 16);

    // Mélange sur fond blanc (255)
    const Rf = Math.round((1 - A) * 255 + A * R);
    const Gf = Math.round((1 - A) * 255 + A * G);
    const Bf = Math.round((1 - A) * 255 + A * B);

    return (
      Rf.toString(16).padStart(2, "0").toUpperCase() +
      Gf.toString(16).padStart(2, "0").toUpperCase() +
      Bf.toString(16).padStart(2, "0").toUpperCase()
    );
  }


  /**
   * demande d'export depuis l'IHM
   * @param filename nom du fichier cible
   * @param widget source
   * @param cols les colonnes à dessiner
   * @param rawArr la matrice de données
   * @param binColumns médias montées en mémoire
   * @param intercept pas de génération de fichier, mode PDF
   * @returns 
   */
  public doExportAsExcel(
    filename: string, 
    widget: IWidget, 
    cols: Column[],
    rawArr: string[][],
    binColumns: Map<number, Column>,
    intercept: boolean = false): Worksheet {
    
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('allkeyme');

    const grid: WizAgGrid<any> = widget['agGrid'];
    const allGp: any[] = grid.columnApi.getAllDisplayedColumnGroups(); // prise des groupes / colonnes
    
    let countHeader: number = 1; // profondeur d'entête
    let gpDeep: IHeaderColumn = allGp[0]; // on prend le 1er, tous les groupes ont la même profondeur
    while(gpDeep.hasOwnProperty('children')) {
      // console.log('deep', gpDeep);
      countHeader++;
      gpDeep = gpDeep['children'][0];
    }

    // création du tableau de header
    const deep: number = 0; // profondeur de l'entête
    const headerArr: ExcelExportColumn[][] = []; // pour chaque level, prise des labels et de la taille de la colonne
    const byColMap: Map<any, ExcelExportColumn> = new Map();
    allGp.forEach((c: any) => {
      this.recurseColumnChildren(c, deep, headerArr, byColMap, widget); // construction des rows pour les headers
    });
    console.log('allGp', allGp);

    // création du tableau de total (colonnes, toutes, même les hidden)
    let totalColls: number = null;
    headerArr.forEach((hrow: ExcelExportColumn[]) => {
      worksheet.addRow([]);
      if (!totalColls) { // on compte le nbr de colonnes
        let nb: number = 0;
        hrow.forEach((cell: ExcelExportColumn) => {
          nb+= cell.size;
        })
        totalColls = nb;
      }
    });


    // ajout des lignes de donnée, brut
    worksheet.addRows(rawArr); 



    // prise de la ligne de référence pour les types de colonnes
    let refheader: ExcelExportColumn[] = [...headerArr].pop();
    let idx: number = 1; 
    let worksheetdelta: number = 0; // +1 à chaque fois qu'on slice une colonne
    for(idx; idx<= totalColls; idx++) {
      const colDef: WizColDef = cols[idx-1].getColDef() as WizColDef;
      const fkd: FeiKeyDef = colDef.fkd;
      let eec:ExcelExportColumn = refheader[idx - 1];
      eec.sourceIndex = idx - 1; // l'indice dans rawData
      eec.columnIndex = idx - worksheetdelta; // l'indice de colonne

      if(!colDef.wcio?.exportable || colDef.wcio?.hiddenCol) { // colonne masqué, on tag le ExcelExportColumn 
        eec.hidden = true;
        worksheetdelta++;
        worksheet.spliceColumns(eec.columnIndex, 1);
      }
      // console.log('refheader', colDef)
    }

    //#######
    //## application des formats
    //#######
    let refIdx: number = 1;
    refheader.forEach(eec => {
      if(!eec.hidden) {
        // console.log(eec)
        const colDef: WizColDef = eec.colDef as WizColDef;

        worksheet.getColumn(refIdx).style.numFmt = '0';
        
        let baseSize: number = 120;
        if(colDef.datakind === FIELD_KIND.COMMENT || 
          colDef.datakind === FIELD_KIND.WORKFLOW ||
          colDef.datakind === FIELD_KIND.LIST ||
          colDef.datakind === FIELD_KIND.THRESHOLD
        ) { // champ comment, plus large
          baseSize = 240;
        } 

        let pixels = colDef.wcio.csiz || colDef.wcio.cmsiz || baseSize;

        const excelWidth = Math.ceil((pixels - 5) / 7) + 2; // ≈ 16,4
        // console.log('width', eec.label, excelWidth);
        worksheet.getColumn(refIdx).width = excelWidth;

        const fkd:FeiKeyDef = colDef.fkd;
        if (!!fkd) {
          // style des cellules
          if(!!eec.cellBackground || !!eec.cellFont || !!eec.cellBold) {
              
              // si 8 digit, alpha
              let cellBackground: string = 'unset';
              if(eec.cellBackground && eec.cellBackground !=='unset') {
                cellBackground = this.argbToRgbOnWhite(this.toArgbHex(eec.cellBackground));
                
                // if(eec.cellBackground.length === 8) { 
                //   cellBackground = eec.cellBackground.substring(7,8) + eec.cellBackground.substring(0,6);
                //   console.log('', eec.cellBackground, cellBackground);
                // } else {
                //   cellBackground = 'FF' + eec.cellBackground;
                // }
              }
              
              
              
              const cellfont = eec.cellFont && eec.cellFont !=='unset' ? 'FF' + eec.cellFont: 'unset';
              const bold: boolean = eec.cellBold === 'bold';
            
              // application des styles
              worksheet.getColumn(refIdx).eachCell((cell: Cell) => {
                if (Number(cell.row) > countHeader){
                  if(cellBackground !== 'unset') {
                    cell.fill = {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: { argb: cellBackground },
                      bgColor: { argb: cellBackground },
                    };
                  }
                  cell.font = { color: { argb: cellfont }, bold };
                        
                } 
              });
          }

          // format on prend le datakind du format. Les listes et Objets sont polymorphes
          switch (colDef.datakind) { 
            case FIELD_KIND.INT:
            case FIELD_KIND.NUMBER:
              // console.log('number format', colDef);
              let fmt: string = '0'; 
              if(colDef.datakind === FIELD_KIND.NUMBER) {
                fmt = '# #0.00';
              }
              if(colDef.dataformat === "*|PERCENT") {
                fmt = '# #0.00"%"';
              }
              if(colDef.dataformat?.indexOf("|EUR") > -1) {
                fmt = '# #0.00"€"';
              }
              
              // FormatEngine.splitNumberParts(formatRegExp);
              worksheet.getColumn(refIdx).eachCell((cell: Cell) => {
                if (Number(cell.row) > countHeader){
                  if(!isNaN(Number(cell.value))) {
                    cell.value = +cell.value // convert a string value to a number value
                    cell.style.numFmt = fmt;
                    // console.log('convert to num', cell.value);
                  }
                  
                } 
              });
              break;
            case FIELD_KIND.DATE:
              worksheet.getColumn(refIdx).eachCell((cell: Cell) => {
                if (Number(cell.row) > countHeader){
                  if(!isNaN(Number(cell.value)) && Number(cell.value) > 0) {
                    cell.value = +cell.value // convert a string value to a number value
                    cell.style.numFmt = 'dd/mm/yyyy';
                    // console.log('convert to date', cell.value);
                  }
                  
                } 
              });
              // worksheet.getColumn(idx).style.numFmt = 'dd/mm/yyyy' ;
              break;
            case FIELD_KIND.STRING:
            case FIELD_KIND.COMMENT:
            case FIELD_KIND.WORKFLOW:
            case FIELD_KIND.LIST:
            case FIELD_KIND.THRESHOLD:
              worksheet.getColumn(refIdx).alignment = { wrapText: true };
            case FIELD_KIND.BOOLEAN:
            default:
              // rien
              break;
          }
        }
        refIdx++;
      }

    });


    //#######
    //## gestion des entêtes
    //#######

    // dessin des entêtes
    let hidx: number = 1;
    headerArr.forEach((coll: ExcelExportColumn[]) => {
      
      let headerRow: Row = worksheet.getRow(hidx);
      hidx++;
      const rowIdx: number = headerRow.number;
      let columnIdx: number = 1;
      
      // console.log('gestion des entêtes', refheader, coll);

      // TODO dessiner depuis les EEc: pour le 0, prendre les colonnes du 1
      // si tout hidden, hidden.

      // let oneMergeOnly= false;
      coll.forEach((eec: ExcelExportColumn) => {
        
        if(!eec.hidden) {
          // console.log('asked', columnIdx, eec.size + columnIdx -1, eec.label);
          if(eec.size > 1) {//  && !oneMergeOnly) {
            let targetCell: number = (eec.size + columnIdx)-1;
            worksheet.mergeCells(rowIdx, columnIdx, rowIdx, targetCell);
            // console.log('merge', columnIdx, targetCell, eec.label);
            // oneMergeOnly = true;
          } else {
            // console.log('no merge', columnIdx, eec.label);
          }
          const cell: Cell = headerRow.getCell(columnIdx);
          cell.value = eec.label;
          cell.alignment = { wrapText: true, horizontal: 'center', vertical:'middle' };

          let background = 'FFe9e9e9';
          let font = 'FF000000';
          // let bold: boolean = eec.cellBold === 'bold';

          // style par défaut sur le grid si c'est unset
          if(!!widget.context.hsty) {
            let cleanStr = widget.context.hsty.replace(new RegExp(ViewData.CONTEXT_SEPARATOR, 'g'), '')
            let parts: string[] = cleanStr.split(WizConstants.KEY_SEPARATOR);
            
            if(parts[0] && parts[0] !=='unset') {
              background = 'FF' + parts[0];
            }
            if(parts[1] && parts[1] !=='unset') {
              font = 'FF' + parts[1];
            }
          }

          if(eec.background && eec.background !=='unset') {
            background = 'FF' + eec.background;
          }
          if(eec.font && eec.font !=='unset') {
            font = 'FF' + eec.font;
          }

          // couleur par défaut des backgrounds
          // const background = eec.background && eec.background !== "unset" ? 'FF' + eec.background: 'FFe9e9e9';
          // const font = eec.font ? 'FF' + eec.font : 'FF000000';
          if (!!cell.value) {
            if(!!background) {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: background },
                bgColor: { argb: background },
              };
            }
            cell.font = { color: { argb: font }, bold: true };
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' },
            };
          }
          // worksheet.getCell(rowIdx, columnIdx).value = eec.label;
          columnIdx += eec.size;
        }

      });
    });


    // injection des médias si nécessaires
    // Traitement des colonnes pour ajout effectif des images ExcelJS
    if(binColumns?.size > 0) {
      refheader.forEach(eec => {
          const colDef: any = eec.colDef;
          if (! eec.hidden && (colDef?.datakind === FIELD_KIND.BINARY || colDef?.datakind === FIELD_KIND.BINARY_MULTI)) {
            for(let row = 0; row < rawArr.length; row++) {
              // console.log('row', rawArr[row]);
              const imageData = rawArr[row][eec.sourceIndex];
              if (imageData && typeof imageData === 'string') {
                // Gestion base64 complet ou pur :
                let imgBase64 = imageData;
                let extension: any = 'png';
                if (!imgBase64.startsWith('data:')) {
                  // Détermine le mimetype si possible (ajuste WizFileUtils selon ton outil)
                  const mime = WizFileUtils.detectImageMimeType(imgBase64) || 'image/png';
                  extension = mime.split('/')[1] || 'png';
                  imgBase64 = `data:${mime};base64,${imgBase64}`;
                } else {
                  const detected = imgBase64.match(/^data:image\/([^;]+);/);
                  if (detected && detected[1]) extension = detected[1];
                }
                // Ajoute l'image à ExcelJS
                const imageId = workbook.addImage({
                  base64: imgBase64,
                  extension
                });
                // Placement de l'image sur le worksheet (identifiant ExcelJS commence à 1)
                //console.log('col1:',worksheet.getRow(row).getCell(1).value, row);
                worksheet.getRow(row  + 1 + countHeader).height = 50;
                // console.log('addimg', eec );
                worksheet.addImage(imageId, {
                  tl: { col: eec.columnIndex - 1, row: row   + countHeader},
                  ext: { width: 64, height: 64 }
                });
                // Optionnel : efface la valeur dans la cellule, ou remplace par "IMAGE"
                
                
              }
              worksheet.getRow(row + 1 + countHeader).getCell(eec.columnIndex).value = '';
            }
          }
      });
    }


    if(intercept) {
      return worksheet;
    } else {
      // génération du fichier
      workbook.xlsx.writeBuffer().then((book) => {
        const blob = new Blob([book], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        fs.saveAs(blob, filename + '.xlsx');
      });
    }


  }

  /** 
   * retourne la taille réelle de l'entête de colonne (en nbr de colonnes)
   * 
   * @param colGP objet groupe de colonnes
   * @param deep profondeur souhaitée
   * @param matrix de colonnes par niveau
   * @param byColMap la map des colonnes construites, pour mesure précise des groupes
   * @param widget cible
   * @returns 
   */
  private recurseColumnChildren(colGP: any, deep: number, matrix: ExcelExportColumn[][], byColMap: Map<any, ExcelExportColumn>, widget: IWidget): number {
    // taille cible
    let result: number = 0;

    // une colonne groupée, on va demander aux enfants de se compte
    let hiddenChildren: number = 0;

    if (!matrix[deep]) { // création du niveau si inexistant
      matrix[deep] = [];
    }

    if (!!colGP.colId) {  // une colonne simple, taille = 1
      result = 1; 
      const expCol: ExcelExportColumn = this.buildExportColumn(colGP, widget.context, result);
      let wcol: WizColDef = (colGP as Column).getColDef() as WizColDef;
      if(!wcol?.fkd) { // seulement les colonnes exportables, pas les del & select
        // console.log('hidden col TEK', colGP);
        expCol.hidden = true;
      } else {
        if(!wcol.wcio.exportable) {
          // console.log('hidden col no export', colGP);
          expCol.hidden = true;
        }
        if(wcol.wcio.hiddenCol) {
          // console.log('hidden col hiddenCol', colGP);
          expCol.hidden = true;
        }
      }


      matrix[deep].push(expCol);
      byColMap.set(colGP, expCol);

    } else { // un groupe
      (colGP as ColumnGroup).getDisplayedChildren().forEach((sub: any) => {
     
        // construction de l'enfant
        result += this.recurseColumnChildren(sub, deep + 1, matrix, byColMap, widget);
        
        // on regarde son hidden
        let childExp: ExcelExportColumn = byColMap.get(sub);
        // console.log('subs', colGP, childExp);
        if(childExp.hidden) {
          hiddenChildren++;
        }
      });
      // prise du contexte du grid pour skinning
      // const ctx: WidgetConfigurationObj = widget.context;
      // console.log('grid context', ctx);
      const expCol: ExcelExportColumn = this.buildExportColumn(colGP, widget.context, result, true);
      if(hiddenChildren === result) { // tous mes enfants sont masqués
        // console.log('hidden group ', expCol);
        expCol.hidden = true;
      }
      // correction de la taille pour enlever les colonnes masquées
      expCol.size = result - hiddenChildren;

      matrix[deep].push(expCol);
    }
    return result;
  }

  /**
   * construction d'une cellule d'entête
   * 
   * @param colDef définition de la colonne
   * @param context config
   * @param size taille souhaitée
   * @param grp appartient à un groupe d'entête ?
   * @param idx indice dans le rawData
   * @returns ExcelExportColumn
   */
  private buildExportColumn(colGP: any, context: WidgetConfigurationObj, size: number, grp: boolean = false): ExcelExportColumn {
    
    let colDef: any;
    if(grp) {
      colDef = (colGP as ColumnGroup).getOriginalColumnGroup().getColGroupDef();
    } else {
      colDef = (colGP as Column).getColDef();
    }
    
    let result: ExcelExportColumn = {size: size, label: colDef.headerName, colDef};
    try {
      if(grp) { // skinning des groupes de colonnes
        const grps: Map<string, WidgetConfigurationItemObj> = new Map(context.g.map(item => [item.cod, item]));
        const meGrp: WidgetConfigurationItemObj = grps.get(colDef.groupId);
        
        // ici, prise du style conditionnel si existe
        // console.log('meGrp', meGrp); 
        // // ici, prise de l'héritage ? ou mieux, du défault aggStyle ?
        // console.log('colDef?.wcio', colDef?.wcio); 
        //         // gestion du headColorField si existe
        // if(!!colDef.wcio?.headColorField) {
          
        // }


        // console.log('grid context', context);
        let cleanStr;
        if (!!meGrp?.hsty) { // groupes classiques
          cleanStr = meGrp.hsty.replace(new RegExp(ViewData.CONTEXT_SEPARATOR, 'g'), ''); //(ViewData.CONTEXT_SEPARATOR, '');
          result.background = cleanStr.split(ViewData.KEY_SEPARATOR)[0];
          result.font = cleanStr.split(ViewData.KEY_SEPARATOR)[1];
        } else if(colDef?.style) { // couleurs custom sur pivot.column
          cleanStr = colDef.style.replace(new RegExp(ViewData.CONTEXT_SEPARATOR, 'g'), ''); //(ViewData.CONTEXT_SEPARATOR, '');
          result.background = cleanStr.split(ViewData.KEY_SEPARATOR)[0];
          result.font = cleanStr.split(ViewData.KEY_SEPARATOR)[1];
        }

      } else {
        
        // style de header ou héritage
        let headStyle: string = colDef?.wcio?.hsty || null;
        
        // puis écrasement par l'héritage si existe
        try {
          if(!!colDef.wcio?.headInherit) {
            let daddyStyle = colGP.parent.getOriginalColumnGroup().getColGroupDef().style;
            if(daddyStyle) {
              headStyle = daddyStyle;
            }
          }
        } catch(e: any) {

        }

        if (!!headStyle) {
            const cleanStr = headStyle.replace(new RegExp(ViewData.CONTEXT_SEPARATOR, 'g'), ''); // (ViewData.CONTEXT_SEPARATOR, '');
            result.background = cleanStr.split(ViewData.KEY_SEPARATOR)[0];
            result.font = cleanStr.split(ViewData.KEY_SEPARATOR)[1];
        } 

        if (!!colDef?.wcio?.csty) {
            const cleanStr = colDef.wcio.csty.replace(new RegExp(ViewData.CONTEXT_SEPARATOR, 'g'), ''); // (ViewData.CONTEXT_SEPARATOR, '');
            let cleanStrArr: string[] = cleanStr.split(ViewData.KEY_SEPARATOR);
            result.cellBackground = cleanStrArr[0];
            result.cellFont = cleanStrArr[1];
            if(cleanStrArr.length >= 3) {
              result.cellBold = cleanStrArr[2];
            }
            
        } 
      }   
    } catch(e: any) {}

    return result;
  }

  /**
   * demande d'export depuis l'IHM, Widget de type LIST
   * @param filename nom du fichier cible
   * @param datas string[][] collection de [label, value]
   * @param label titre de la colonne
   */
  public exportAsExcelFromList(filename: string, datas: string[][], label: string): void {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('allkeyme');

    const row: [string, string] = ['', label];
    const headerRow = worksheet.addRow(row); // Add Header Row
    headerRow.eachCell((cell, number) => {
      // skin de la ligne de titre
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF7f052a' },
        bgColor: { argb: 'FF7f052a' },
      };
      cell.font = { color: { argb: 'FFFFFFFF' } };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    worksheet.addRows(datas); // ajout des lignes de donnée

    let idx: number = 1; // gestion de la taille des colonnes et forçage en numérique si possible
    row.forEach((item) => {
      worksheet.getColumn(idx).style.numFmt = '0';
      worksheet.getColumn(idx).width = 20;
      worksheet.getColumn(idx).eachCell((cell: Cell) => {
        if (Number(cell.row) > 1 && !isNaN(Number(cell.value))) {
          cell.value = +cell.value;
        }
      });
      idx++;
    });

    // génération du fichier
    workbook.xlsx.writeBuffer().then((book) => {
      const blob = new Blob([book], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, filename + '.xlsx');
    });
  }


  /** 
   * ctrl + c ou drop d'un fichier excel sur un pivot
   * va construire l'objet ExcelSheetVo
   * et le transmettre au widget, qui va déclencher le type d'import (FREEDATA / BASELINE)
   * @param widget 
   * @param file 
   */
  public readExcelFile(widget: IWidget, file: File): void {
    let result: ExcelSheetVo = null;
    if (file !== null) {
      // console.log(file);
   
      let targetSheet: any = 1;
      if(!!widget.context?.xlsSheet) {
        targetSheet = widget.context.xlsSheet;
      }

      const workbook = new Workbook();

      const arryBuffer = new Response(file).arrayBuffer();
      arryBuffer.then(function (data) {
        workbook.xlsx.load(data)
          .then(function () {
            // play with workbook and worksheet now
            // console.log(workbook);
            const worksheet = workbook.getWorksheet(targetSheet)
            if(!!worksheet) {
              result = new ExcelSheetVo();
              result.build(worksheet);
              widget.fileDrop(result);
            } else {
              WizPopUp.toast('$.excel.drop.nosheet.$', WizIcon.TOAST_WARNING).show();
            }

          });
      });
    }
  }

  /**
   * dépose d'un fichier excel en mode BASELINE
   * @param sheet le fichier
   * @param pivot le pivot
   */
  public excelDrop(sheet: ExcelSheetVo, widget: IWidget): void {
    
    if(!widget.context.xlsU) { // contrôle: droit en update / create
        WizPopUp.toast('$.excel.drop.disallowed.$', WizIcon.TOAST_WARNING).show();
      return;
    }
    
    // prise des colonnes sur le grid
    const grid: WizAgGrid<any> = widget['agGrid'];
    const colls: Column[] = grid.columnApi.getAllColumns();
    const colMap: Map<string, ExcelColumn> = new Map(); // l'ensemble des colonnes

    // les colonnes éditables, que l'on va alimenter
    // en cas d'update, seules ces colonnes seront alimentées sur la baseline, pour ne pas perdre l'existant
    const editableColsMap: Map<string, string> = new Map(); 

    // controle de cohérence des hiérarchies et alimentation auto si possible
    colls.forEach((col: any)=> {
      if(!!col?.colDef?.fkd) {
        const ec: ExcelColumn = {key: col.getColDef().headerName, column: col, fkd: col.colDef.fkd, field: col.colDef.field };
        let ignore: boolean = false; // ignorer la col (FD sous champs, mesures non éditables)
        if(ec.fkd.isScen) {
          // rien à faire de spécial
        } else if (ec.fkd.isFreedata) { // freedata, création de la map
                  
          const fdvs: FreedataValueVO[] = this.model.freedataEngine.getFreedataValuesByLevel(ec.fkd.fullCode);
          const subf: string = col.colDef.wcio.fdvf ? col.colDef.wcio.fdvf : 'label';
          ec.fdvs = new Map(fdvs.map(fdv => [fdv.argsObjVO[subf], fdv]));

          // console.log('ici', ec);
          const args: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(ec.field.split(ViewData.CONTEXT_SEPARATOR)[0]);
          const field = col.colDef.fdvfield;
          
          args.forEach(arg => {
            if(arg.code === field) {
              // console.log('arg trouvé', arg);
              if( arg.code === 'shortCode' || 
                  arg.code === 'code' || 
                  arg.code === 'externalCode' || 
                  arg.code === 'label' ) {
                // console.log('ici ok', arg);
              } else {
                // console.log('ignore FD', arg, ec.key);
                ignore = true;
              }
            }
          });

          if(!ignore && ec.fkd.isFilterKey) {
            editableColsMap.set(col.colDef.field, null);
          }
       } else if (ec.fkd.isChrono) { // chrono

          let mainChrono: ChronocodeVO = this.model.chronocodeEngine.getChronocode(this.model.currentVision.chronoCode);
          const chrons: ChronocodeVO[] = this.model.chronocodeEngine.getChildrenByLevel(mainChrono, ec.fkd.level);
          
          let mapkey: string = 'label';
          if(!!col.colDef?.fdvfield) {
            mapkey = col.colDef.fdvfield;
          }
          // console.log('col.fdvfield', col.colDef?.fdvfield);
          let map = new Map();
          chrons?.forEach(cro => {
            map.set(this.model.chronocodeEngine.getChronoValue(cro, mapkey), cro);
          });
          // // prise du field sur la colonne
          // this.model.chronocodeEngine.getChronoValue()
          
          ec.chrons = map;  //new Map(chrons.map(chron => [chron.trsLabel, chron]));
          // contrôle de cohérence, la map doit être de la même taille que chrons..

       } else { // les mesures ??
     
          const meas: MeasureVO = this.model.measureEngine.getMeasure(this.model.visionCode, widget.fei.visionStepLevel, ec.fkd.code );
          if(ec.fkd.editable) {
            // console.log('ignore measure', ec.pkd);
            editableColsMap.set(col.colDef.field, null);
          } else if(ec.fkd.mode === WizConstants.MEASURE_MODE_SUBMIT && !meas.formulaS) {
            editableColsMap.set(col.colDef.field, null);
          }
           else {
            ignore = true;
          }
        
       }

        if(!ignore) {
          colMap.set(col.getColDef().headerName, ec );
        } 
      }
    });

    // console.log('colMap', colMap);
    // en cas de parent unique, alimentation du prototype de map
    let masterKeyMap: Map<string, string> = new Map(); // je mémorise les clés du master s'il est unique
    
    let masterWidget: IWidget = this.model.widgetEngine.checkFirstMaster(widget);
    if(!!masterWidget) {
      if (masterWidget.visionStep?.level < widget.settings.vs) {
        let src: WidgetLine[] = masterWidget.mainDS?.selectedItems; // on essaye le selectedItem
        if(src.length <= 0) {
          src = masterWidget.mainDS?.getWorkedSource(); // ou tout le pool si pas de sélection
        }
  
        if (src?.length === 1) {
          const wl: WidgetLine  = src[0];
          masterKeyMap.set(wl.scen, wl.scen); // ajout du scenar
          const trio: {[key: string]: string} = BaselineEngine.feedAllKeys(widget.fei, wl.bl);
          Object.keys(trio).forEach(key => {
            masterKeyMap.set(key, trio[key]);
          })
        }
      }
    }


    // construction de la map des triggers et des valeurs par défaut
      /** valeurs par défaut et triggers pour chaque champ, par clé de champ#level */
    let triggersMap: Map<string, Triggers> = new Map();
    widget.fei.editableKeys.forEach((fkd: FeiKeyDef) => {
      let triggers: Set<string> = new Set();
      let defaultValue: string = null;
      if(fkd.isFreedata) { // c'est une filterKey
        let freedata: FreeDataVO = this.model.freedataEngine.getFreeData(fkd.code); // là, on veut juste le code
        defaultValue = freedata?.defaultValue;
        if(!!defaultValue) {
          if(!!freedata.defaultTrigger) {
            triggers = new Set(freedata.defaultTrigger.split(ViewData.KEY_SEPARATOR));
          }
          triggersMap.set(fkd.fullCode, { fkd, defaultValue, triggers }); // mais on mémorise par code#level
        }
      } else if(fkd.isMeasure) { // defaultValue et triggerValue sur les mesures
        let measure: Measure = fkd.measure;
        if(measure.defaultValue) {
          let fakeDefaultValueKey: string = [WizConstants.FAKE_DEFAULT_VALUE, measure.shortCode].join(ViewData.CODE_LEVEL_SEPARATOR);
          const mm: MeasMode = MeasureCoreEngine.LightFakeMeasureMode(
            widget.fei,
            fakeDefaultValueKey,
            WizConstants.MEASURE_MODE_SUBMIT,
            measure.defaultValue);
          if(!!mm.deps) {
            [...mm.deps.values()].forEach(s => {
              triggers.add(s);
            })
          }
          triggersMap.set(fakeDefaultValueKey, { fkd, defaultValue: measure.defaultValue, mm, triggers }); // mémorisation du trigger
        }
        if(measure.triggerValue) {
          let fakeTriggerValueKey: string = [WizConstants.FAKE_TRIGGER, measure.shortCode].join(ViewData.CODE_LEVEL_SEPARATOR);
          const mm: MeasMode = MeasureCoreEngine.LightFakeMeasureMode(
            widget.fei,
            fakeTriggerValueKey,
            WizConstants.MEASURE_MODE_SUBMIT,
            measure.triggerValue);
            if(!!mm.deps) {
              [...mm.deps.values()].forEach(s => {
                triggers.add(s);
              })
            }
            triggersMap.set(fakeTriggerValueKey, { fkd, defaultValue: measure.defaultValue, mm, triggers }); // mémorisation du trigger
        }
      }
    });

    // objets de retours: BLs et updates
    // let resultNewBornBaselines: Map<FeiVO, Baseline[]> = null; // BLs à créer
    let resultUpdates: UpdateEntry[] = null; // maj sur des Baselines / BLVs

    let doubleCheck : Map<string,Map<string, Set<string>>> = new Map(); // map de contrôle de doublon scen = Key = bl.key. en set, le FDV ou * pour create bl
    let hasError: boolean = false; // erreur lors de l'intégration
    let proto: Baseline; // le prototype à construire depuis les keys
    let row: Row;

    let errorMessages: Map<number, KeyPair> = new Map();

    // pour chaque ligne
    for (let index = 0; index < sheet.rawRows?.length; index++) {
      row = sheet.rawRows[index];
          
      proto = null; // reset du prototype
      hasError = false; // reset de l'erreur

      if(errorMessages.size > 10) {
        let mess: string = WizTranslationManager.getInstance().translateKey('$.excel.import.toomany.$');
        errorMessages.set(index, {l: mess, r: null, s: index});
        break; // trop d'erreurs, faut recommencer, merci
      }

      const keyPartMap: Map<string, string> = new Map([...editableColsMap, ...masterKeyMap]); // construction des clés depuis le master, si existe
      keyPartMap.set(ViewData.SCEN_KEY_CODE, null); // ajout de la clé de scenar  

      // le pack d'updates
      const updates: UpdateEntry[] = []; // les lignes à mettre à jour, encapsulées en DataUpdateObj 
      
      // une erreur lors du contrôle de la valeur de la cellule sur un restrict

      let rowRestrictError: boolean = false;
      let rowRestrictField: string = null;
      row.eachCell((cell: Cell, colNumber: number) => { // pour chaque cellule
        const head: string = sheet.rawHead[colNumber-1];
        const gridCol: ExcelColumn = colMap.get(head);
        // console.log('gridCol', gridCol);
        if (!!gridCol) { // la colonne existe dans le grid (et ce n'est pas un subField)
          let value: any = cell.value;
          if (value && typeof value === 'object' && 'result' in value) {
            value = value.result;
          }
          // console.log('cell', cell.address, value);

          if(gridCol.fkd.isScen) {
            // rien à faire, on prend le scen.. s'il existe dans mon fei
            // TODO TODO 
            // if(!pivot.fei.scenlevelsMap.has(value)) {
            //   hasError = true;
            // }
            // console.log('scen OK', value);
          } else if(gridCol.fkd.isFreedata) {
            // TODO ici, uniquement si champ de base (pas de subField)
            // console.log('FDV key ?', gridCol);
            let fdv: FreedataValueVO;
            if(gridCol.fkd.isSequence) {
              // rien à faire, c'est un code de séquence
            } else {
              fdv = gridCol.fdvs.get(value?.toString());
              if(!!fdv) {
                value = fdv.code;
              } else {
                // console.log('excel import wrong fdv value', gridCol.field, value);
                value = null;
                //error = true;
              }
            }
          } else if(gridCol.fkd.isChrono) {
            const chron = gridCol.chrons.get(value?.toString());
            
            // console.log('val from chron',gridCol.fkd, value);
            if(!!chron) {
              // console.log('gotMyCron',gridCol.field, chron, keyPartMap);
               // en récursif, alimentation des valeurs depuis le parent
              let dadChron: ChronocodeVO = chron.parentVO;
              while(!!dadChron) {
                keyPartMap.set([WizConstants.CHRONO,dadChron.level].join(WizConstants.CONTEXT_SEPARATOR) , dadChron.code);
                dadChron = dadChron.parentVO;
              }
             

              value = chron.code;
            } else {
              // console.log('excel import wrong chrono value', gridCol.field, value);
              value = null;
              // error = true;
            }
          } else if (gridCol.fkd.isMeasure) {      
            value = this.valueOverride(cell);

            // mise en upperCase
            if(value?.length > 0 && gridCol.fkd.measure.upper) {
              value = value.toUpperCase();
            }

            // jouer les restricts
            if(gridCol.fkd.measure.editRegex) {
              let regex: RegExp = new RegExp('^'+gridCol.fkd.measure.editRegex+'$');
              if(value?.length > 0 && !regex.test(value)) {
                rowRestrictError = true;
                rowRestrictField = gridCol.key;
                // console.log('restrict error', gridCol.fkd.measure.code, value);
              }
            }

          }

          keyPartMap.set(gridCol.field, value);

          if(rowRestrictError) { // inutile de continuer, la ligne est HS
            return;
          }

        }
      });

      if(!rowRestrictError) { // création seulement si aucune erreur de saisie
        // création du prototype de baseline 
        proto = this.createNewBaseline(keyPartMap, widget.fei, null, false);      
      }


      if(!proto) { // manque un morceau de la clé ou erreur sur le restrict
        let mess: string;
        if(rowRestrictError) {
          mess = WizTranslationManager.getInstance().translateKey('$.baseline.create.error.restrict.$', [rowRestrictField]);
        } else {
          mess = WizTranslationManager.getInstance().translateKey('$.baseline.create.error.parts.$');
        }
        
        mess = mess + ': ';
        mess = mess + (row.values as CellValue[]).filter(item => item?.toString().length > 0).join(ViewData.STYLE_ELEMENT_SEPARATOR);
        errorMessages.set(index + 1, {l: mess, r: null, s: index});
        continue;
      } 

      let realBL: Baseline = null; // la baseline à modifier / créer
      let wl: WidgetLine; // la widgetLine à modifier / créer

      let dlo: DataLoadObj = this.model.widgetDataService.getDataloadByKey(proto.v, proto.level, proto.scen); // le dataload porteur de la collection existante
      let upd: UpdateEntry;
      realBL = dlo.localBaselines[proto.key]; // on recherche l'existant

      if (realBL) { // la ligne existe, génération des updates
        // on prend la widgetLine
        wl = widget.fei.getWidgetLineForKey(realBL.scen, realBL.key);

        let fkd: FeiKeyDef;
        Array.from(keyPartMap.keys()).forEach((key: string) => {
          if(editableColsMap.has(key)) { // en cas d'update, on n'écrase QUE les colonnes éditables
            // console.log('updateMode', key, keyPartMap.get(key));
            fkd = BaselineEngine.getKey(widget.fei, key);
            if (!!fkd && (fkd.isMeasure || fkd.isFilterKey)) {
              upd = this.model.dataEngine.generateUpdate(widget.fei, wl, fkd, keyPartMap.get(key));
              if(!this.model.dataEngine.equals(upd.newValue,upd.oldValue)) {
                updates.push(upd);
              }
              
            }
          }
        });

        updates.forEach((upd: UpdateEntry) => { // contrôle de cohérence
          if(doubleCheck.get(upd.baseline.scen)?.get(upd.baseline.key)?.has(upd.field)) { // doublon, pas bon
            let mess: string = WizTranslationManager.getInstance().translateKey('$.baseline.create.error.twins.$');
            mess = mess + ': ';
            mess = mess + (row.values as CellValue[]).filter(item => item?.toString().length > 0).join(ViewData.STYLE_ELEMENT_SEPARATOR);
            errorMessages.set(index + 1, {l: mess, r: null, s: index});
            hasError = true;
          }
        }); 
      } else {// la ligne n'existe pas, création, seulement si autorisé
        
        if(!!widget.context.xlsC) {
       
          realBL = this.createNewBaseline(keyPartMap, widget.fei, null, false);
          realBL.operation = EM_ACTION.CREATE;
          // contrôle d'unicité
          if(doubleCheck.get(realBL.scen)?.has(realBL.key)) { // oups, 2x même ligne
            let mess: string = WizTranslationManager.getInstance().translateKey('$.baseline.create.error.twins.$');
            mess = mess + ': ';
            mess = mess + (row.values as CellValue[]).filter(item => item?.toString().length > 0).join(ViewData.STYLE_ELEMENT_SEPARATOR);
            errorMessages.set(index + 1, {l: mess, r: null, s: index});
            hasError = true;
          } else {
            wl = this.model.dataEngine.baselineToWidgetLine(widget.fei, realBL.scen, realBL);

            // alimentation des champs par défaut
            [...triggersMap.keys()].forEach((trigKey: string) => {
              let formTrig: Triggers = triggersMap.get(trigKey);
              
              // TODO TODO seulement si non alimenté dans keyPartMap
              if(!keyPartMap.get(formTrig.fkd.fullCode) || keyPartMap.get(formTrig.fkd.fullCode) === null) {
                if (formTrig.defaultValue !== null) {
                  if(formTrig.fkd.isFreedata) { // trigger issus du Freedata
                    const triggeredValue: string = this.model.widgetEngine.computeDefaultValue(widget.fei, wl, formTrig.fkd.fullCode);
                    keyPartMap.set(formTrig.fkd.fullCode, triggeredValue);
                    // console.log('feed default mesure', formTrig.fkd.fullCode, triggeredValue);
                    BaselineEngine.baselineSetFilterKeyValue(wl.bl, formTrig.fkd.fullCode, triggeredValue);
                  } else if(formTrig.fkd.isMeasure && !trigKey.startsWith(WizConstants.FAKE_TRIGGER)) { // defaultValue sur une mesure (on ne joue pas les triggers)
                    const cr: ComputeResult = FormulaCoreEngine.computeMmiDependencies(formTrig.mm.mmi, wl, widget.fei, true, keyPartMap);
                    if(cr?.valor?.length > 0) {
                      // console.log('feed default mesure', formTrig.fkd.fullCode, cr.valor);
                      keyPartMap.set(formTrig.fkd.fullCode, cr.valor);  
                      // mettre à jour la matrice
                      BaselineEngine.baselineSetValue(wl.bl, formTrig.fkd.fullCode, cr.valor);
                      let ibas: IBaselineValue =  this.model.cellMatrixEngine.addCell(wl.level, wl.key, wl.scen, formTrig.fkd.fullCode, cr.valor);
                      wl.cells.set(ibas.m, {l: wl.level, k: wl.key, sc: wl.scen, m: ibas.m});
                    }
                  }
                }
              } else {
                // console.log('default feeded', trigKey, )
              }

            });

            updates.push(this.model.dataEngine.generateUpdate(widget.fei, wl, null, null));
          }
        }
      }

      // contrôles de cohérence
      // console.log('Excel', wl, updates);

      // la demande
      const updateRequest: UpdateRequest = {
        fei: widget.fei, 
        line: wl,
        lines: [wl], 
        operation: EM_ACTION.UPDATE,
        fkd: null, // pas de contrôle sur une mesure, contrôle sur l'ensemble
        value: null,
        doSplit: false
      };

      // TODO TODO prise en compte du message d'erreur
      let checkResult: boolean = widget.checkBeforeCommit(updateRequest, updates, true);
      if(!checkResult) {
        let mess: string = WizTranslationManager.getInstance().translateKey('$.baseline.create.error.integrity.$');
        mess = mess + ': ';
        mess = mess + (row.values as CellValue[]).filter(item => item?.toString().length > 0).join(ViewData.STYLE_ELEMENT_SEPARATOR);
        errorMessages.set(index + 1, {l: mess, r: null, s: index});
        hasError = true;
      }
      // console.log('Excel result', wl.key, checkResult);

      if(hasError) { // erreur lors de la construction du prototype
        continue;
      }

      if(!resultUpdates) { // ajout des updates
        resultUpdates = [];
      }
      resultUpdates = resultUpdates.concat(updates);

      // WizPopUp.toast(mess, WizIcon.TOAST_WARNING, 5000, true, false, "300px", "150px").show();
      // console.log('2x line create', row);

      // mise à jour de la map de modif pour unicité
      updates.forEach((upd: UpdateEntry) => {
        if(!doubleCheck.has(upd.baseline.scen)) {
          doubleCheck.set(upd.baseline.scen, new Map());
        }
        if(!doubleCheck.get(upd.baseline.scen).has(upd.baseline.key)){ // doublon, pas bon
          doubleCheck.get(upd.baseline.scen).set(upd.baseline.key, new Set());
        }
        doubleCheck.get(upd.baseline.scen).get(upd.baseline.key).add(upd.field || WizConstants.wildcardDomain);
      });

    }

    if(errorMessages.size > 0) {
      // [...errorMessages.keys()].forEach((idx: number) => {
      //   console.log('err: ', idx + 1, errorMessages.get(idx));
      // });

      const errPop: WizPopUp = new WizPopUp(ExcelErrorPop, false, false, null, ExcelErrorPop.width, ExcelErrorPop.height, [this.model, [...errorMessages.values()]]);
      if (PopUpManager.exist(errPop)) { // suppression de l'instance existante
        errPop.hide();
      }
      // ouverture de la pop
      errPop.show();
    } else {
      const csp: CompositeSourcePack =  { updates: resultUpdates };
      this.model.compositeEngine.compositeCommit(csp);
    }
  }

  /**
   * export des erreurs lors d'un drop Excel
   * @param errors sous forme de collection de Keypair
   */
  public exportError(errors: KeyPair[]): void {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('allkeyme');

    const rawArr: string[][] = errors.map((s) => [s.s, s.l]);

    const rowLabel: string = WizTranslationManager.getInstance().translateKey('$.excel.import.row.$');
    const errLabel: string = WizTranslationManager.getInstance().translateKey('$.excel.import.error.$');
    const row: [string, string] = [rowLabel, errLabel];
    const headerRow = worksheet.addRow(row); // Add Header Row
    headerRow.eachCell((cell, number) => {
      // skin de la ligne de titre
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF7f052a' },
        bgColor: { argb: 'FF7f052a' },
      };
      cell.font = { color: { argb: 'FFFFFFFF' } };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    worksheet.addRows(rawArr); // ajout des lignes de donnée

    let idx: number = 1; // gestion de la taille des colonnes et forçage en numérique si possible
    row.forEach((item) => {
      worksheet.getColumn(idx).style.numFmt = '0';
      worksheet.getColumn(idx).width = 20;
      worksheet.getColumn(idx).eachCell((cell: Cell) => {
        if (Number(cell.row) > 1 && !isNaN(Number(cell.value))) {
          cell.value = +cell.value;
        }
      });
      idx++;
    });

    // génération du fichier
    workbook.xlsx.writeBuffer().then((book) => {
      const blob = new Blob([book], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'errors.xlsx');
    });
  
  }

  /**
   * mise en conformité des valeurs de cellule
   * @param cell 
   * @returns 
   */
  private valueOverride(cell: Cell): any {
    let value: any = cell.value;
    if (value && typeof value === 'object' && 'result' in value) {
      value = value.result;
    }

    // conversion de type
    if(value !== null && value !== undefined) { // on doit garder les 0
      switch(cell.type) {
        case 2: // Number = 2,
          value = WizNumberUtils.toRealNumber(value.toString());
        break;
        case 4: // Date = 4,
          if(!!value) {
            let dateNum = WizDateUtils.dateToNumber(value);
            if(dateNum) {
              value = dateNum.toString();
            } else {
              value = null;
            }
          }
        break;
        case 3: // String = 3,
        default:
          // rien à faire, déjà texte
        break; 
      } 
    }
    return value;
  }


  /**
   * en cas de champ complexe sur un FDV, retour le code du sous-FDV
   * @param argCode 
   * @param value 
   */
  private getSubArg(arg: FreedataArgsVO, targetField: string, value: string): string {
    // TODO TODO mémoriser les résultats déjà identifiés dans argResultMap Map<code> = value => code du SubFDV
    // la liste des valeurs de FDV pour le args
    // console.log('getSubArg2 targetField', targetField);
    const subs: FreedataValueVO[] = this.model.freedataEngine.getFreedataValuesByLevel(arg.datas);
    
    let result: Map<string, string> = new Map();
    
    subs.forEach((fdv: FreedataValueVO) => {
      let real = this.model.freedataEngine.getFDValue(fdv, targetField);
      // console.log('getSubArg2', real, value);
      if(real === value) {
        result.set(real, arg.datas.split(ViewData.CONTEXT_SEPARATOR)[0] + ViewData.CONTEXT_SEPARATOR + fdv.code);
      }
    });

    if(result.size > 0) {
      /// console.log("result", result);
      return [...result.values()][0];
    } else {
      // console.log('value no result', value);
      return null;
    }
  }
  

  // private argResultMap: Map<string, Map<string, string>> = null;


  /**
   * contrôles de base sur un nouveau FDV
   * @param fdv 
   * @returns string le message d'erreur
   */
  private checkFDVIntegrity(fdv: FreedataValueVO): string {
    let result: string = null;
    if(!fdv.code) {
      result = '$.fdv.missing.code.$';
    }
    else if(!fdv.shortCode) {
      result = '$.fdv.missing.shortcode.$';
    }
    else if(!fdv.label) {
      result = '$.fdv.missing.label.$';
    }
    else if(fdv.level > 1 && !fdv.parentCode) {
      result = '$.fdv.missing.parentcode.$';
    }
    return result;
  }


    /**
   * dépose d'un fichier excel sur un pivot Freedata
   * @param sheet le fichier
   * @param widget le FDGrid
   * @param callBack du pivot pour refrehs
   */
    public excelDropFreedata(sheet: ExcelSheetVo, widget: IFreedataWidget): void { 

      // contrôle: droit en update / create
      if(!widget.context.xlsU) {
          WizPopUp.toast('$.excel.drop.disallowed.$', WizIcon.TOAST_WARNING).show();
        return;
      }

      // on récupère le FD source
      const sourceFD: FreeDataVO = this.model.freedataEngine.getFreeData(widget.freedataCode);
      sourceFD.resetUpdateMap(); // on rince la map de modifs

      // on crée la map des args, par code
      const argsMap: Map<string, FreedataArgsVO> = new Map(sourceFD.allFieldsAsArgs.map(arg => [arg.code, arg]));
  
      // on crée la map des workflows à persister...
      const workflowMap: Map<string, WorkComVO> = new Map();

      // prise des colonnes du widget
      const colls: Column[] = (widget as any).agGrid.columnApi.getAllColumns();   
      // const colls: Column[] = (widget as FreedataGridWidget).agGrid.columnApi.getAllColumns();   
      
      // préparation des colonnes Excel
      const colMap: Map<string, ExcelColumn> = new Map();

      // controle de cohérence des hiérarchies et alimentation auto si possible
      // alimentation de la map des colonnes Excel
      colls.forEach((col: any)=> {
        if(!!col?.colDef?.fkd) { // sera toujours le même, celui du FD#level
          const ec: ExcelColumn = {key: col.getColDef().headerName, column: col, fkd: col.colDef.fkd, field: col.colDef.fdvfield };
          colMap.set(col.getColDef().headerName, ec );
        }
      });
      
      let row: Row;
      let errorMessages: Map<number, KeyPair> = new Map();
      let value: any; // la valeur des cellules
      let arg: FreedataArgsVO; // le arg correspondant à la colonne

      // map pour contrôle d'unicité
      let updateMap: Map<string, FreedataValueVO> = new Map();

      // pour chaque ligne
      for (let index = 0; index < sheet.rawRows?.length; index++) {
        row = sheet.rawRows[index];

        if(errorMessages.size > 10) {
          let mess: string = WizTranslationManager.getInstance().translateKey('$.excel.import.toomany.$');
          errorMessages.set(index, {l: mess, r: null, s: index});
          break; // trop d'erreurs, faut recommencer, merci
        }

        const keyPartMap: Map<string, string> = new Map(); // construction des clés
        let hasUpdate: boolean = false; // modif détectée
        
        row.eachCell((cell: Cell, colNumber: number) => { // pour chaque cellule

          const head: string = sheet.rawHead[colNumber-1];
          const gridCol: ExcelColumn = colMap.get(head);

          if (!!gridCol) { // la colonne existe dans le grid
            value = this.valueOverride(cell);
            let ignore: boolean = false;
            let fieldParts: string[] = gridCol.field.split(WizConstants.FD_PARTS_SEPARATOR);
            
            arg = argsMap.get(fieldParts[0]);
            // console.log('fdCell', gridCol.field, arg, value);

            // gestion des champs complexes
            if(arg.dataType === FIELD_KIND.OBJECT) { // sousFD. On cherche sa valeur réelle, pas le string
              if(fieldParts.length === 2) { // il y a un subField
                //let secondPartIsGood: boolean = fieldParts[1] === WizConstants.FIELD_CODE || fieldParts[1] === WizConstants.FIELD_SHORT_CODE;
                //if(secondPartIsGood) {
                value = this.getSubArg(arg, fieldParts[1], value);
                // } else {
                //console.log('OBJ not good', value, fieldParts);
                //   // console.log('fieldParts', fieldParts, value);
                //   ignore = true;
                // }
              } else { // champ brut de fonderie, c'est bon aussi
                value = this.getSubArg(arg, WizConstants.FIELD_CODE, value);
                // du coup, rien à faire // value = this.getSubArg(arg.datas, value);
              }
              
            } else if(arg.dataType === FIELD_KIND.WORKFLOW) { // gestion des workflows, il faut les persister, donner leur code, et alimenter le FDV...
              // TODO génération du workflow, collecte de son naturalUID, alimentation de la map
              // TODO gestion des champs obj, comment
              // console.log('WORKFLOW', value);
              if(!!value) {
                try {
                  let wcObj: WorkcomParameters = JSON.parse(value);
                  let wc: WorkComVO = this.model.workflowEngine.buildFake();
                  wc.params = wcObj;
                  wc.obj = wcObj?.object;
                  wc.comment = wcObj?.comment;
                  workflowMap.set(wc.naturalUID, wc);
                  value = wc.naturalUID;
                } catch(e:any) {
                }
              }

            }

            if(!ignore) {
              keyPartMap.set(fieldParts[0], value);    
            }     
          }
        });
  
        // simple pour commencer. On prend le code, on cherche l'équivalent, on update les args (les vrais)
        let existFDV: FreedataValueVO = null;
        let cloneFDV: FreedataValueVO = null;
        const code: string = keyPartMap.get(WizConstants.FIELD_CODE);
        const shortCode: string = keyPartMap.get(WizConstants.FIELD_SHORT_CODE);
        if (code) {
          existFDV = sourceFD.getFreeDataValue(code);
        }
        if(!existFDV && !widget.context.xlsNusc && shortCode) { // seulement si âs  unicité de code court
          const shorts: FreedataValueVO[] = sourceFD.getFreeDataValueByShortCode(shortCode);
          if(shorts?.length === 1) {
            existFDV = shorts[0];
          } 
        }
  
        if(existFDV) { // mise à jour
          cloneFDV = this.model.freedataEngine.cloneFDV(existFDV); // création du clone de travail
          const existArgs :any = cloneFDV.trueArgsObj;
          keyPartMap.delete(WizConstants.FIELD_CODE); // pas de Maj sur code
          keyPartMap.delete(WizConstants.FIELD_SHORT_CODE); // pas de Maj sur shortCode
          [...keyPartMap.keys()].forEach((key: string) => {
            const existVal: string = existArgs[key];
            const newVal: string = keyPartMap.get(key);            
            if(newVal !== existVal) { // vraie modif sur une clé du FD ??
              hasUpdate = true;
              // modification du champ cible
              this.model.freedataEngine.feedFreedataValueField(cloneFDV, key, newVal);
            }
          });

          // console.log('existFDV', existFDV, cloneFDV);
        } else { // demande de création, seulement si autorisé
          if(!widget.context.xlsC) {
            continue;
          }

          // si le code n'est pas alimenté, on prend le short
          if(!keyPartMap.get(WizConstants.FIELD_CODE)) { 
            keyPartMap.set(WizConstants.FIELD_CODE, keyPartMap.get(WizConstants.FIELD_SHORT_CODE)); 
          }

          let parentVO: FreedataValueVO = this.model.widgetEngine.findMasterParentUnicity(widget) || null;
          
          // on a alimenté le code parent
          if(!parentVO && !!keyPartMap.get(WizConstants.FIELD_PARENT_CODE)) {
            parentVO = this.model.freedataEngine.getFreedataValue(sourceFD.code, keyPartMap.get(WizConstants.FIELD_PARENT_CODE));
          }
          
          cloneFDV = this.model.freedataEngine.createFreeDataValue(sourceFD, parentVO);
          [...keyPartMap.keys()].forEach((key: string) => {
            const newVal: string = keyPartMap.get(key);            
            // modification du champ cible
            this.model.freedataEngine.feedFreedataValueField(cloneFDV, key, newVal);
          });

          // contrôle d'intégrité
          let errorStr: string = this.checkFDVIntegrity(cloneFDV);
          if(errorStr) {
            let mess: string = WizTranslationManager.getInstance().translateKey(errorStr);
            mess = mess + ': ';
            mess = mess + (row.values as CellValue[]).filter(item => item?.toString().length > 0).join(ViewData.STYLE_ELEMENT_SEPARATOR);
            errorMessages.set(index, {l: mess, r: null, s: index});
          } else {
            hasUpdate = true;
          }         
          // console.log('createFDV', cloneFDV, hasUpdate);
        }
        
        let updates: UpdateEntry[] = null;
        if(hasUpdate) {
          if(updateMap.has(cloneFDV.code)) { // contrôle d'unicité
            let mess: string = WizTranslationManager.getInstance().translateKey('$.baseline.create.error.twins.$');
            mess = mess + ': ';
            mess = mess + (row.values as CellValue[]).filter(item => item?.toString().length > 0).join(ViewData.STYLE_ELEMENT_SEPARATOR);
            errorMessages.set(index, {l: mess, r: null, s: index});
          } else {
            updateMap.set(cloneFDV.code, cloneFDV);
            if(!!cloneFDV.exist) {
              sourceFD.addToUpdatePack(cloneFDV,EM_ACTION.UPDATE);
            } else {
              sourceFD.addToUpdatePack(cloneFDV,EM_ACTION.CREATE);
            }
          }
        }

      }
  
      // TODO TODO gérer le CRUD sur les baselines

      if(errorMessages.size > 0) {
        const errPop: WizPopUp = new WizPopUp(ExcelErrorPop, false, false, null, ExcelErrorPop.width, ExcelErrorPop.height, [this.model, [...errorMessages.values()]]);
        if (PopUpManager.exist(errPop)) { // suppression de l'instance existante
          errPop.hide();
        }
        // ouverture de la pop
        errPop.show();
      } else {
        if(sourceFD.updateMap.size > 0) { 
          
          // on regarde si on gère les baselines, si oui, création sur le step
          // le FDV doit porter tous les champs de la clé de baseline, donc potentiellement des args de type OBJECT
          // donc possibilité de création, update en cas de modifs des args
          // TODO TODO prendre le FEI du widget
          
          // en cas de baselines liées
          let updates: UpdateEntry[] = null;
          if(!!widget.fei) { // step asservi
            updates = this.model.freedataEngine.generateSlaveBaselines(sourceFD, widget);
            // console.log('slaves', widget.fei, updates);
          }
          
          const csp: CompositeSourcePack = {
            freedata: sourceFD, // update / create / delete sur FDV
            freedataManagement: true,
            updates, // maj sur des Baselines / BLVs
          }
          // console.log('csp', csp);

          // si workFlow, d'abord enregistrement, puis commit
          if(workflowMap.size > 0) {
            new WorkcomCommitCmd(this.model).commits([...workflowMap.values()], csp, this.excelDropFreedata2.bind(this)).execute();
          } else {
            this.excelDropFreedata3(csp);
          }

          

        }
      }
    }

  private excelDropFreedata2(cmd:WorkcomCommitCmd): void {
    // console.log('WorkcomCommitCmd', cmd.sourcePack);
    this.model.workcomSyncService.eatRemote(cmd.result);
    this.excelDropFreedata3(cmd.csp);
  }
  private excelDropFreedata3(csp: CompositeSourcePack): void {
    // ViewData.doEnd('ExcelExport IHM');
    this.model.compositeEngine.compositeCommit(csp); // compositeMerge(csp);
  }

  /**
   * création d'une nouvelle baseline et persistence
   * @param keyMap la map <visionKey|visionFilterKey|measure = value>
   * @param fei le fei cible
   * @param callback méthode de retour vers le formulaire de création
   * @param persist ...persister en BDD
   * @param noError création systématique (mode init sur Form)
   */
  public createNewBaseline(keyMap: Map<string, string>, fei: FeiVO, callback: Function, persist: boolean = true, noError: boolean = false ): Baseline {
    // construction de la key
    const key: string[] = [];
    let pkey: string = null;
    const filterKey: Object = {}; // string[] = [];
    const scen: string = keyMap.get(ViewData.SCEN_KEY_CODE);
    let hasError: boolean = false;


    fei.visionKeys.forEach((fkd: FeiKeyDef) => {
        // si c'est une séquence, on alimente keyUpdates & 
        let rawVal: string = null; // la valeur pour la clé de FEI
        if(fkd.isSequence) {
          key.push(this.model.freedataEngine.getNextSequence(fei, fkd));
        } else {
          // keys
          key.push(keyMap.get(fkd.fullCode));
          const val: string = keyMap.get(fkd.fullCode);
          if(!noError) { // pas d'erreur en mode création sur un form
            if ((!val || val.length === 0) && !hasError) {
              // WizPopUp.toast('$.baseline.create.error.parts.$', WizIcon.TOAST_ERROR).show();
              hasError = true;
            }
          }
        }
    });

    // const vitals: [string, string][] = [];
    // let visionkeys: VisionKey[] = BaselineEngine.getStepKeys(fei.vision, fei.visionStep);
    // visionkeys.forEach((vk: VisionKey) => {
      
  
    //   // keys
    //   key.push(keyMap.get(vk.code));
    //   const val: string = keyMap.get(vk.code);
    //   if(!noError) { // pas d'erreur en mode création sur un form
    //     if ((!val || val.length === 0) && !hasError) {
    //       // WizPopUp.toast('$.baseline.create.error.parts.$', WizIcon.TOAST_ERROR).show();
    //       hasError = true;
    //     }
    //   }

    // });

    if (hasError) {
      // // manque un morceau de la clé
      return null;
    }

    if (fei.visionStep.level > 1) {
      // construction de la pkey
      // TODO TODO 
      let vis: VisionVO = this.model.visionEngine.getVision(fei.visionCode);
      let nbKeyPrev: number = vis.keySizeByLevel.get(fei.visionStep.level -1);
      pkey = key.slice(0, nbKeyPrev).join(ViewData.KEY_SEPARATOR);
      
    }

    Object.values(fei.vision.visionFilterKeys || {}).forEach((vk: VisionFilterKey) => {
      // filtres
      let fkVal: string = '';
      if (keyMap.has(vk.code)) {
        fkVal = keyMap.get(vk.code);
      }
      if (!!fkVal) {
        filterKey[vk.code] = fkVal;
      }
      // filterKey.push(fkVal);
    });

    const bl: Baseline = new Baseline();
    bl.domain = this.model.domainCode;
    bl.businessUnitCode = this.model.businessUnitCode;
    bl.v = fei.visionStep.visionCode;
    bl.vs = fei.visionStep.code;
    bl.chron = fei.visionStep.chronoCode;
    bl.level = fei.visionStep.level;
    bl.key = key.join(ViewData.KEY_SEPARATOR);
    if(fei.scenario === ViewData.SCEN_KEY_CODE) {
      bl.scen = scen || ViewData.DEFAULT_SCENARIO;
    } else {
      bl.scen = fei.scenario;
    }
    
    bl.values = {};
    bl.uid = WizMathUtils.createUUID();
    bl.pkey = pkey; // .length > 0 ? pkey.join(ViewData.KEY_SEPARATOR) : '';
    bl.fkeyjson = filterKey; // filterKey.length > 0 ? filterKey.join(ViewData.KEY_SEPARATOR) : '';
    // console.log('create bl', bl.fkeyjson);
    fei.keys.forEach((fkd: FeiKeyDef) => {
      if (fkd.editable && !fkd.isKey) {
        // une mesure éditable

        if (keyMap.has(fkd.fullCode)) {
          const val: string = keyMap.get(fkd.fullCode);
          const blv: BaselineValue = BaselineEngine.generateNewBaselineValue(bl, fkd.fullCode);
          blv.valor = val;
          bl.values[fkd.fullCode] = blv;
        }
      }
    });
    return bl; // retour de la BL pour préparation des protos dans les subForms
  }


  /* ##############################################################################
        Export des grids simples
  ############################################################################## */

  /**
   * demande d'export depuis l'IHM, wizAgGrid (mode spécif)
   * @param filename nom du fichier cible
   * @param grid: WizAgGrid<any>
   */
  public exportAsExcelFromGrid(filename: string, grid: WizAgGrid<any>): void {
    
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('allkeyme');
    const cols: Column[] = grid.columnApi.getAllDisplayedColumns(); //  []; // grid.columnApi.getAllColumns(); // prise de toutes les colonnes basiques, pour le rendu
    let params : any  = { columnSeparator: ViewData.EXCEL_EXPORT_SEPARATOR, suppressQuotes: true };

    // extraction des lignes
    const rawData: string[] = grid.api
      .getDataAsCsv(params)
      .split(/\r\n/);
    const rawArr: string[][] = rawData.map((s) => s.split(ViewData.EXCEL_EXPORT_SEPARATOR));
    
    if (rawData.length <= 1) {
      // pas de données, pas d'export
      return;
    }

    // gestion des entêtes
    const row: string[] = [...cols.map(col => WizTranslationManager.getInstance().translateKey(col.getColDef().headerName))];
    const headerRow = worksheet.addRow(row); // Add Header Row
    headerRow.eachCell((cell, number) => {
      // skin de la ligne de titre
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF34557E' },
        bgColor: { argb: 'FF34557E' },
      };
      cell.font = { color: { argb: 'FFFFFFFF' } };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    worksheet.addRows(rawArr.slice(1, rawArr.length)); // ajout des lignes de donnée


    let idx: number = 1; // gestion de la taille des colonnes et forçage en numérique si possible
    row.forEach((item) => {
      worksheet.getColumn(idx).style.numFmt = '0';
      worksheet.getColumn(idx).width = 20;
      worksheet.getColumn(idx).eachCell((cell: Cell) => {
        if (Number(cell.row) > 1 && !isNaN(Number(cell.value))) {
          cell.value = +cell.value;
        }
      });
      idx++;
    });

    // génération du fichier
    workbook.xlsx.writeBuffer().then((book) => {
      const blob = new Blob([book], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, filename + '.xlsx');
    });
  }


  /**
   * conversion des images en bytes
   * @param file 
   * @returns 
   */
  public async readFile(file):Promise<string | ArrayBuffer> {
    return new Promise((resolve, reject) => {
      var fr = new FileReader();  
      fr.onload = () => {
        resolve(fr.result )
      };
      fr.onerror = reject;
      fr.readAsDataURL(file);
    });
  }

  /**
   * conversion des widgets en images
   * @param element 
   * @returns 
   */
  public async doImg(pdfPage: PDFPage): Promise<PDFPage> {
    const DATA = pdfPage.element.nativeElement;
    let first: any = await domtoimagemore.toBlob(DATA);
    var base64data: string | ArrayBuffer = await this.readFile(first);
    pdfPage.bin = base64data;
    return pdfPage;
  }

  /**
   * demande d'export depuis l'IHM, image en PDF
   * @param filename nom du fichier cible
   * @param widget source
   */
  public pdfReport(filename: string, elements: PDFPage[]): void {

    // TODO TODO passer un param
    let maxX: number = 595; // largeur max de la page
    let maxY: number = 842 - 20; // hauteur max de la page

    
    // les contenus à générer en HTML, c'est sync
    let toHtml: PDFPage[] = [];
      
    // les images à résoudre, c'est Async
    let promises: Promise<any>[] = [];

    // on marque le dernier élément pour éviter le saut de page
    elements[elements.length - 1].lastPage = true;

    elements.forEach((pdfPage: PDFPage) => {
      if(pdfPage.kind === PDF_PAGE_KIND.IMAGE) {
        promises.push(this.doImg(pdfPage));
      } else {
        toHtml.push(this.doHtml(pdfPage));
      } 
    });

    if(promises.length > 0) { // des actions asynchrones
        
      Promise.all(promises).then((imagePages: PDFPage[]) => {
        imagePages.forEach(pdfPage => {
          let scaleRatio: number = 1;
          let finalWidth = pdfPage.width;
          let finalHeight = pdfPage.height;
          if(pdfPage.width > maxX) {
            scaleRatio = Math.round(maxX*100/pdfPage.width)/100;
            finalWidth = pdfPage.width*scaleRatio;
            finalHeight = pdfPage.height*scaleRatio;
          }
          let content: any;
          // gestion du header
          if(pdfPage.isHeader) {
            content = {image: pdfPage.bin, width: finalWidth, height: finalHeight, margin: [20 + (maxX - finalWidth)/2, 0, 10, 0], alignment: "left"};
          } else {
            content = {image: pdfPage.bin, fit: [finalWidth, finalHeight],alignment: "center", margin: [10, (maxY - finalHeight)/2, 10, 10]};
            content.noHead = pdfPage.noHead;
            content.noFoot = pdfPage.noFoot;
            // margin: [(maxX - finalWidth)/2, (maxY - finalHeight)/2, 0, 0]};
            if(!pdfPage.lastPage) {
              content.pageBreak = 'after';
            }
          }

          pdfPage.content = [content];
        });
        this.mergePDFPages(filename, elements);
      });
    } else {
        this.mergePDFPages(filename, elements);
    }
  }

  /**
   * assemblage du PDF
   * @param filename 
   * @param elements 
   */
  public mergePDFPages(filename: string, elements: PDFPage[]): void {

      let header: any = null;
      let marginTop: number = 20; // prise en compte du header
      let content: any[] = [];
      
      elements.forEach((pdfPage: PDFPage) => { // alimentation des contenus
        if(pdfPage.isHeader) {
          header = pdfPage.content[0];
          marginTop = header.height;
        } else {
          content.push(pdfPage.content);
        }
      });

      if(header) {
        let idx: number = 1;
        content.forEach(c => {
          if(idx <= 2) {
            c[0].margin[1] = -marginTop + 20;
          }
          idx++;
        });
      }


      // application de la marge sur les pages avec header si header

      // configuration du PDF
      const docDefinition: any = {
        pageSize: 'A4',
        pageOrientation: 'portrait',

        header: function(currentPage, pageCount) {
          let result: any = null;
          if(!!header && currentPage > 2) {
            result = header;
          }
          return result;
        },
        footer: function(currentPage, pageCount) {
          let result: any = null;
          if(currentPage > 1) {
            return [{
              text: "Page " + currentPage.toString() + " of " + pageCount.toString(),
              alignment: "right",
              fontSize: 8,
              margin: [0, 0, 10, 10]
            }, ];
          }

          return result;
        },     
        content,
        pageMargins: [0, marginTop, 0, 20],
        //pageMargins: [10, marginTop + 40, 10, 20],
      };

      pdfMake.createPdf(docDefinition).download(filename + '.pdf');
     
  }

  private generatePDFCell(cell: Cell, group: boolean = false): any {
    let text: string;
    let fillColor: string =  '#FFFFFF';
    let bold: boolean = false;
    let color: string = '#000000';
    let fontSize: number = 7;
    let alignment: string = 'left';
    let borders: any = [false, false, group, false];

    text = cell.value.toString();
    try {
      fillColor ='#'+ (cell.fill['bgColor']['argb'] as string).substring(2,8);
    } catch(e:any){
    }
    try {
      color ='#'+ (cell.font['color']['argb'] as string).substring(2,8);
    } catch(e:any){
    }

    if(cell.font.hasOwnProperty('bold')) {
      bold = !!cell.font['bold'];
    }
    
    if(cell.type === 2) {
      alignment = 'right';
    }

    try {
      alignment =cell.alignment['horizontal'];
      // console.log('align', text, alignment);
    } catch(e:any){
    }

    if(!!cell.numFmt) {
      text = this.formatHack(text, cell.numFmt); // TODO TODO prise des vrais formats
      // console.log('cell', cell.numFmt);
    }
   
    return {text, fillColor, color, bold, fontSize, borders, alignment};
  }


  /**
   * conversion d'une liste ou d'un grid en HTML

   * @param element: PDFPage
   */
  public doHtml(pdfPage: PDFPage): PDFPage {

    const worksheet = this.exportAsExcel('void', pdfPage.widget, true);
    // console.log('worksheet', worksheet);

    let body: any[] = [];
    let rows: Row[] = worksheet.getRows(1, worksheet.rowCount);
    
    let headerPrototype: Row = rows.reverse().pop(); // extraction du header
    rows.reverse();
    let cell: Cell;
    let idx: number = 1;
    

    let headerResult: any[] = []; // génération des formats des entêtes
    let colSpan: number;
    let oneRowResult: any[] = []; // génération des formats des lignes
    let groupResult: any[] = []; // génération des formats des groupes
    
    let headerCollIndex: Set<number> = new Set(); // les index des colonnes qui servent pour les groupes
    let lastHeaderContent: string = null; // le dernier groupe identifié

    (headerPrototype.values as CellValue[]).forEach((cellValue: CellValue) => {
      cell = headerPrototype.getCell(idx);
      let headCell: any = this.generatePDFCell(cell);
      if(headCell.text.indexOf('#HEAD') > -1) { // interception des cellules de regroupement
        headerCollIndex.add(idx);
      } else {
        headerResult.push(headCell);
      }
      idx++;
    });
    colSpan = headerResult.length;
    body.push(headerResult); // ajout du résultat au body
    
    rows.forEach((r:Row) => {
      oneRowResult = [];
      groupResult = [];
      idx = 1;
      (r.values  as CellValue[]).forEach((cellValue: CellValue) => {
        cell = r.getCell(idx);
        let rowCell: any = this.generatePDFCell(cell, headerCollIndex.has(idx));
        if(headerCollIndex.has(idx)) {
          groupResult.push(rowCell);
        } else {
          oneRowResult.push(rowCell);
        }
        idx++;
      });

      let currentHeads: string[] = [];
      let currentHead: string;
      groupResult.forEach(groupCell => {
        currentHeads.push(groupCell.text);
      });
      currentHead = currentHeads.join(WizConstants.KEY_SEPARATOR);
      // console.log('currentHead', currentHead);
      if(currentHead !== lastHeaderContent) {
        lastHeaderContent = currentHead;
        let cleanGP: any[] = [];
        groupResult.forEach(gp => {
          cleanGP.push(gp);
          cleanGP.push({text: '    '});
        });
        let headRow: any = {colSpan, text: cleanGP, border:[false, true, false], borderColor: ['#f1f1f1', '#f1f1f1', '#f1f1f1', '#f1f1f1']};
        body.push([headRow]); // ajout du résultat au body
      }

      body.push(oneRowResult); // ajout du résultat au body

    });

    let content: any ={
            noHead: pdfPage.noHead,
            noFoot: pdfPage.noFoot,
            layout: {
              defaultBorder:false,
            },
            margin: [10, 10, 10, 10],
            dontBreakRows: true,
            columns: [
                { width: '*', text: '' }, //pour centrage
                {
                    width: 'auto',
                    table: {
                    headerRows: 1,
                    body,
                    alignment: "center",
                    heights: 20, // hauteur des lignes
                    },
                    layout: //'lightHorizontalLines',                  
                    {
                      defaultBorder:false,
                    },
                },
                { width: '*', text: '' }, // pour centrage
            ]
      };
    if(!pdfPage.lastPage) {
      content.pageBreak = 'after';
    }
    pdfPage.content = [content];


    return pdfPage;
  }

  private formatHack(text: string, format: string): string {
    let result: string = text;
    if(text && format) {
      if(format === '# #0.00"€"') {
        result = Number(text).toFixed(2) + ' €';
      }
    }

    return result;
  }


}
